import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ContentsHeader from './ContentsHeader';
import ContentTable from './ContentsTable';


export default function Contents(param) {
    // const [selectedMenu, setSelectedMenu] = React.useState('BLOG');
    const [blogSelectCheck, setBlogSelectCheck] = React.useState('nav-link active');
    const [cardSelectCheck, setcardSelectCheck] = React.useState('nav-link');
    const [quizSelectCheck, setquizSelectCheck] = React.useState('nav-link');
    const [surveySelectCheck, setSurveySelectCheck] = React.useState('nav-link');
    const [type, setType] = useState("blogs");

    // function changeMenu(e){
    //     setSelectedMenu(e.target.value);
    // }


    function typeSelect(value) {
        setType(value);
    }

    React.useEffect(() => {
        if(param.match.params.type !== undefined) {
            if(param.match.params.type == 'blogs') {
                setBlogSelectCheck('nav-link active');
                setcardSelectCheck('nav-link');
                setquizSelectCheck('nav-link');
                setSurveySelectCheck('nav-link');
            } else if(param.match.params.type == 'cards') {
                setBlogSelectCheck('nav-link');
                setcardSelectCheck('nav-link active');
                setquizSelectCheck('nav-link');
                setSurveySelectCheck('nav-link');
            } else if(param.match.params.type == 'quiz') {
                setBlogSelectCheck('nav-link');
                setcardSelectCheck('nav-link');
                setquizSelectCheck('nav-link active');
                setSurveySelectCheck('nav-link');
            } else if(param.match.params.type == 'surveys') {
                setBlogSelectCheck('nav-link');
                setcardSelectCheck('nav-link');
                setquizSelectCheck('nav-link');
                setSurveySelectCheck('nav-link active');
            }
            setType(param.match.params.type);
        }
        
    }, [param.match.params.type])


    return(
        <div>
            <div className="content-wrapper">
                <ContentsHeader />
                <section className="content" >
                    <div className="row">
                            <div className="col-12">
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">콘텐츠 조회</h3>
                                    <div className="card-header-image">
                                        <Link to= {"/contents/" + type + "create"} data-toggle="tooltip" title="새 콘텐츠 등록" ><i className="fas fa-plus"></i> 새 콘텐츠 추가</Link>                                    
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="tab-wrapper">
                                        <ul className="nav nav-tabs" id="custom-content-below-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={blogSelectCheck} id="custom-content-below-home-tab" data-toggle="pill" href="#custom-content-below-home" role="tab" aria-controls="custom-content-below-home" aria-selected="true" onClick={() => typeSelect("blogs")}>블로그</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={cardSelectCheck} id="custom-content-below-profile-tab" data-toggle="pill" href="#custom-content-below-profile" role="tab" aria-controls="custom-content-below-profile" aria-selected="false" onClick={() => typeSelect("cards")}>카드</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={quizSelectCheck} id="custom-content-below-messages-tab" data-toggle="pill" href="#custom-content-below-messages" role="tab" aria-controls="custom-content-below-messages" aria-selected="false" onClick={() => typeSelect("quiz")}>퀴즈</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={surveySelectCheck} id="custom-content-below-settings-tab" data-toggle="pill" href="#custom-content-below-settings" role="tab" aria-controls="custom-content-below-settings" aria-selected="false" onClick={() => typeSelect("surveys")}>설문</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <ContentTable type={type}/>
                                </div>
                            </div>

                            <div className="button-wrapper mb-5 col-12" >
                                <Link to= {"/contents/" + type + "create"} ><button type="button" className="btn btn-primary"><i className="fas fa-plus"></i> 새 콘텐츠 추가</button></Link>
                            </div>

                            </div>
                        </div>
                </section>
            </div>
        </div>
        


    );
}